import { render } from "./Q10Component.vue?vue&type=template&id=02e75197&scoped=true"
import script from "./Q10Component.vue?vue&type=script&lang=js"
export * from "./Q10Component.vue?vue&type=script&lang=js"

import "./Q10Component.vue?vue&type=style&index=0&id=02e75197&scoped=true&lang=css"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e75197"]])

export default __exports__